import { ICintorinConfig } from "./common/interfaces";
import { dismissModal, openModal } from "./common/utilities";
import { attachPhotoEventHandlers } from "./fotky";
import { addAuthorization, toggleAuthorizedElementsVisibility } from "./iam";
import { attachCvEventHandlers, attachMemoryActionsEventHandlers, attachMemoryEventHandlers, reloadCv, reloadMemories } from "./spomienky";

declare const CintorinConfig: ICintorinConfig;

export function attachChroniclePickerEvents() {
    let items = document.querySelectorAll("#chroniclePersonDropdown li");
    items.forEach(n => {
        let deceasedId = +n.getAttribute("data-deceased-id");
        n.querySelectorAll("svg").forEach((svg, index) => svg.addEventListener("click", getIconSwitchHandler(index, deceasedId)));
        n.addEventListener("click", handleSwitchChronicleDeceased);
    });
    toggleAuthorizedElementsVisibility("#chronicleContent");
}

export function switchChronicleContext(deceasedId: number, selectedTab?: "cv" | "memo" | "foto") {
    let tabParam = (selectedTab) ? "&selectedTab="+selectedTab :"";

    fetch(CintorinConfig.baseUrl+"/api/chronicle/htmlGetChronicleContent.php?deceasedId="+deceasedId+tabParam, { 
        method: "GET",
        headers: addAuthorization(new Headers())
    })
    .then(response => {
        if (response.ok && response.status == 200) {
            return response.text();
        }
    }).then(resultHtml => {
        if (resultHtml && document.getElementById("chronicleContent")) {
            document.getElementById("chronicleContent").innerHTML = resultHtml;
            let items = document.querySelectorAll("#chroniclePersonDropdown li");
            items.forEach(n => {
                let element = (n as HTMLElement);
                if (+element.getAttribute("data-deceased-id") == deceasedId) {
                    element.classList.add("active");
                    let nameSpan = element.querySelector("span").cloneNode(true);
                    document.getElementById("chronicleSelectedPerson").querySelector("span").replaceWith(nameSpan);
                    document.getElementById("chronicleSelectedPerson").setAttribute("data-deceased-id", deceasedId+"");
                    let dstIcons = document.querySelectorAll("#chronicleSelectedPerson span svg");
                    let srcIcons = element.querySelectorAll("svg");
                    for (let i=0; i<3; i++) {
                        if (srcIcons[i].classList.contains("icon-active")) {
                            dstIcons[i].classList.add("icon-active");
                        } else {
                            dstIcons[i].classList.remove("icon-active");
                        }
                    }
                } else {
                    element.classList.remove("active");
                }
            });
            attachChronicleEventHandlers();
            toggleAuthorizedElementsVisibility("#chronicleContent");
            document.querySelectorAll("#chronicleTabNav li").forEach(li => {
                li.addEventListener("click", function () {
                    gtag("event", "chronicleNavClicked", {chronicleTab: this.getAttribute("data-bs-target")});
                });
            });
        }
    });
}

export function loadOwnershipForm() {
    let hidInput = (document.getElementById("cardHId") as HTMLInputElement);
    if (hidInput) {
        let graveId = +hidInput.value;
        if (graveId) {
            fetch(CintorinConfig.baseUrl+"/api/chronicle/htmlGetGraveOwnership.php?graveId="+graveId, { 
                method: "GET",
                headers: addAuthorization(new Headers())
            })
            .then(response => {
                if (response.ok && response.status == 200) {
                    return response.text();
                }
            }).then(htmlText => {
                let targetElement = document.getElementById("ownershipForm");
                if (targetElement) {
                    targetElement.innerHTML = htmlText;
                    document.getElementById("makeOwnerLink")?.addEventListener("click", handleOwnershipToggleInput(true));
                    document.getElementById("releaseOwnerLink")?.addEventListener("click", handleOwnershipToggleInput(false));
                }
            });
        }
    }
}

export function attachChronicleEventHandlers() {
    document.querySelector("#genericErrorModal .btn")?.addEventListener("click", function () { dismissModal("#genericErrorModal"); });
    document.querySelector("#genericErrorModal .btn-close")?.addEventListener("click", function () { dismissModal("#genericErrorModal"); });
    attachMemoryEventHandlers();
    attachMemoryActionsEventHandlers();
    attachCvEventHandlers();
    attachPhotoEventHandlers();
}

function handleOwnershipToggleInput(ownershipState: boolean) {
    return function () {
        let hidInput = document.querySelector("#cardHId") as HTMLInputElement;
        if (hidInput) {
            changeChronicleOwnership(+hidInput.value, ownershipState);
        }
    }
}

function changeChronicleOwnership(hid: number, ownershipState: boolean) {
    fetch(CintorinConfig.baseUrl+"/api/chronicle/changeOwner.php",  {
        method: "POST",
        headers: addAuthorization(new Headers({'Content-Type': 'application/json'})),
        body: JSON.stringify({
            graveId: hid,
            ownershipState: ownershipState
        })
    }).then(response => {
        if (response.ok && response.status == 200) {
            return response.json();
        }
    }).then(result => {
        if (!result || result.currentStatus != ownershipState) {
            openModal("#genericErrorModal");
        }
        loadOwnershipForm();
        let deceasedId = +(document.getElementById("chronicleSelectedPerson") as HTMLElement).getAttribute("data-deceased-id");
        if (deceasedId) {
            reloadMemories(deceasedId);
            reloadCv();
        }
    });
}

function handleSwitchChronicleDeceased(e: MouseEvent) {
    let filter = false;
    this.querySelectorAll("svg").forEach((svg:any) => filter = filter || svg.contains(e.target));
    if (!filter && this.hasAttribute("data-deceased-id")) {
        switchChronicleContext(+this.getAttribute("data-deceased-id"));
    }
}

function getIconSwitchHandler(index: number, deceasedId: number) {
    return function(e:MouseEvent) {
        switch(index) {
            case 0: return switchChronicleContext(deceasedId, "cv");
            case 1: return switchChronicleContext(deceasedId, "memo");
            case 2: return switchChronicleContext(deceasedId, "foto");
        }
        e.stopImmediatePropagation();
    }
}
